import services from "@/config/services";
import FileManager from "@/services/ask-file-manager/index.js";

export default class PreviewFattureGasService {
  constructor(http, eventBus) {
    this.http = http;
    this.eventBus = eventBus;
    this.baseUrl = `${services.ask_pratiche.url}`;
    this.apiUrl = `${services.ask_api.url}/management`;
    this.filemanager = new FileManager();
  }

  /**
   * @param {number|null} id
   * @param {number} checkFattura
   * @param {number} offset
   * @returns {Promise}
   */
  getDettaglioFattura(id = null, checkFattura = 3, offset = 0) {
    let params = { checkFattura, offset };

    if (id) {
      params.id = id;
    }

    return this.http.get(
      `${this.baseUrl}/fornitori/fatturazione/gas/fattura-dettaglio`,
      { params }
    );
  }

  /**
   * @param {Object} params
   * @returns {Promise}
   */
  getListaFatture(params = {}) {
    return this.http.get(`${this.baseUrl}/fornitori/fatturazione/gas/fatture`, {
      params,
    });
  }

  /**
   * @param {number} id
   * @param {string} action
   * @param {boolean} continua
   * @param {string} note
   * @returns {Promise}
   */
  updateStatoFattura(id, action, continua = false, note = "") {
    if (!note || note.trim() === "") {
      return Promise.reject(new Error("Le note sono obbligatorie"));
    }

    if (note.trim().length < 5) {
      return Promise.reject(
        new Error("Le note devono contenere almeno 5 caratteri")
      );
    }

    const payload = {
      id: id,
      action: action,
      continua: continua,
      note: note.trim(),
    };

    return this.http
      .post(`${this.baseUrl}/fornitori/fatturazione/gas/update-stato`, payload)
      .then((response) => {
        console.log("Risposta updateStatoFattura GAS:", response.data);
        return response;
      })
      .catch((error) => {
        console.error("Errore updateStatoFattura GAS:", error);
        throw error;
      });
  }

  /**
   * @param {number} checkFattura
   * @param {number} offset
   * @returns {Promise}
   */
  getNextFattura(checkFattura = 3, offset = 0) {
    return this.http.get(
      `${this.baseUrl}/fornitori/fatturazione/gas/next-fattura`,
      {
        params: { checkFattura, offset },
      }
    );
  }

  /**
   * @param {number} autofatturaId
   * @returns {Promise}
   */
  getValidazioni(autofatturaId) {
    return this.http.get(
      `${this.baseUrl}/fornitori/fatturazione/gas/fattura/${autofatturaId}/validazioni`
    );
  }

  /**
   * Recupera le letture per un PDR specifico
   * @param {string} codPdr
   * @returns {Promise}
   */
  getLettureByPdr(codPdr) {
    return this.http.get(
      `${this.baseUrl}/fornitori/fatturazione/gas/pdr/${codPdr}/letture`
    );
  }

  /**
   * @param {string} codPdr
   * @returns {Promise}
   */
  getMensilitaByPdr(codPdr) {
    return this.http.get(
      `${this.baseUrl}/fornitori/fatturazione/gas/pdr/${codPdr}/mensilita`
    );
  }

  /**
   * @param {Object} fatturaData
   * @param {string} action
   * @param {string} note
   * @param {boolean} continua
   * @returns {Promise}
   */
  async approvaOScartaFattura(
    fatturaData,
    action,
    note = "",
    continua = false
  ) {
    try {
      if (!note || note.trim() === "") {
        throw new Error("Le note sono obbligatorie per questa operazione");
      }

      const updateResponse = await this.updateStatoFattura(
        fatturaData.autofattura_id,
        action,
        continua,
        note
      );

      if (updateResponse.data.success) {
        return {
          updateSuccess: updateResponse.data.success,
          gestioneSuccess: updateResponse.data.gestione_salvata || true,
          message: updateResponse.data.message,
          gestioneMessage: updateResponse.data.data?.gestione_message || "OK",
          continua_fattura: updateResponse.data.continua_fattura,
          note_salvate: updateResponse.data.data?.note_salvate || note.trim(),
        };
      } else {
        throw new Error(updateResponse.data.message);
      }
    } catch (error) {
      console.error("Errore nell'operazione completa fattura GAS:", error);
      throw error;
    }
  }

  /**
   * @param {Object} gestioneData
   * @param {number} gestioneData.cod_pdr
   * @param {number} gestioneData.tot_smc
   * @param {string} gestioneData.mese
   * @param {boolean} gestioneData.esito
   * @param {number} gestioneData.autofattura_id
   * @param {string} gestioneData.note
   * @returns {Promise}
   */
  salvaGestioneFattura(gestioneData) {
    return this.http.post(
      `${this.baseUrl}/fornitori/fatturazione/gas/salva-gestione`,
      gestioneData
    );
  }

  /**
   * @param {string} codPdr
   * @param {string} periodo
   * @returns {Promise}
   */
  getStatistichePdr(codPdr, periodo = "12m") {
    return this.http.get(
      `${this.baseUrl}/fornitori/fatturazione/gas/pdr/${codPdr}/statistiche`,
      {
        params: { periodo },
      }
    );
  }

  /**
   * Esporta fatture GAS in base ai filtri
   * @param {Object} filtri
   * @returns {Promise}
   */
  esportaFatture(filtri = {}) {
    return this.http.post(
      `${this.baseUrl}/fornitori/fatturazione/gas/export`,
      filtri,
      {
        responseType: "blob",
      }
    );
  }

  async mensilitaRealeUsed2(idPod, idMensilita) {
    let success = false;

    const url = `${this.apiUrl}/pods/${idPod}/mensilita-reali/${idMensilita}/used2`;
    try {
      let res = await this.http.post(url);
      res = res.data;

      success = res.data;
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url });
    } finally {
      this.eventBus.emit('data-load');
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        success
      };
    }
  }
}
